export * from "@vaadin/accordion/vaadin-accordion.js";
export * from './generated/Accordion.js';
